import {BackgroundProcessResource} from "client/resources/backgroundProcessResource";
import splitStringIntoWords from "utils/StringHelper/splitStringIntoWords";

export function getStepDescription(processId: string, stepId: string, processes: BackgroundProcessResource[]) {
    const process = processes.filter(p => p.Id === processId)[0];
    const step = process && process.Steps.filter(s => s.Id === stepId)[0];

    return step && step.Description || splitStringIntoWords(stepId);
}